import React from 'react';
import * as S from './styles';

export interface TimeCardProps {
  time: Date;
  active: boolean;
  onClick: () => void;
}

const TimeCard: React.FC<TimeCardProps> = ({ time, active, onClick }) => {
  return (
    <S.Schedule active={active} onClick={onClick}>
      {time.toTimeString().split(' ')[0].split(':').slice(0, 2).join(':')}
    </S.Schedule>
  );
};

export default TimeCard;
